import React from 'react';
import PropTypes from 'prop-types';

const Button = ({
  onClick,
  text,
}) => (
  <button className="primary-button flex-end" onClick={onClick}>{text}</button>
);

Button.propTypes = {
  onClick: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
};

export default Button;



// WEBPACK FOOTER //
// src/components/atoms/Button/index.jsx